import { Grid, Typography, TextField, Button, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import { AddCircle, RemoveCircle } from "@mui/icons-material";

export default function MitgeltendeUnterlagenForm() {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "mitgeltendeUnterlagen"
  });

  return (
    <Grid container spacing={3} direction="column">
      <Grid item xs={12}>
        <Typography variant="h4" gutterBottom>
          Mitgeltende Unterlagen
        </Typography>
        <Typography variant="body1" gutterBottom>
        Hier erfassen Sie alle ergänzenden Unterlagen, die für die Verfahrensdokumentation relevant sind. Dazu gehören insbesondere Dokumente zu sämtlichen Systemen, die Belege verarbeiten oder erstellen – beispielsweise Kassensysteme, Buchhaltungsprogramme oder ähnliche Anwendungen. Ebenso zählen dazu Nutzungs- und Bedienungsanleitungen, technische Dokumentationen, Handbücher, Richtlinien, Verträge oder andere Unterlagen, auf die innerhalb der Verfahrensdokumentation Bezug genommen wird.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <List>
          {fields.map((item, index) => (
            <ListItem key={item.id} secondaryAction={
              <IconButton edge="end" color="error" onClick={() => remove(index)}>
                <RemoveCircle />
              </IconButton>
            }>
              <Controller
                name={`mitgeltendeUnterlagen.${index}.titel`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} label="Bezeichnung/Link/Referenz" fullWidth />
                )}
              />
            </ListItem>
          ))}
        </List>
        <Button
          startIcon={<AddCircle />}
          variant="outlined"
          sx={{ mt: 2 }}
          onClick={() => append({ titel: "" })}
        >
          Unterlage hinzufügen
        </Button>
      </Grid>
    </Grid>
  );
} 